import { useEffect } from "react";
import { usePreferencesStore } from "@/store/preferences-store";

/** Syncs Zustand theme preference → <html> class for Tailwind dark: variant */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const theme = usePreferencesStore((s) => s.preferences.theme);

  useEffect(() => {
    const html = document.documentElement;

    if (theme === "system") {
      const mq = window.matchMedia("(prefers-color-scheme: dark)");
      html.classList.toggle("dark", mq.matches);
      const handler = (e: MediaQueryListEvent) =>
        html.classList.toggle("dark", e.matches);
      mq.addEventListener("change", handler);
      return () => mq.removeEventListener("change", handler);
    }

    html.classList.toggle("dark", theme === "dark");
  }, [theme]);

  return <>{children}</>;
}
